module.exports = __webpack_public_path__ + "static/thief2-3a2ed2237f2f575ca2efc9ca7fb0a517.jpg";